import { useCallback, useEffect, useState } from 'react'

/**
 * Tracks the visual viewport height, which shrinks when the
 * on-screen keyboard opens on iOS/Android.
 */
export const useVisualViewportHeight = (): number => {
  const [height, setHeight] = useState(() => window.visualViewport?.height ?? window.innerHeight)

  const handleResize = useCallback(() => {
    setHeight(window.visualViewport?.height ?? window.innerHeight)
  }, [])

  useEffect(() => {
    const viewport = window.visualViewport
    if (viewport) {
      viewport.addEventListener('resize', handleResize)
      return () => viewport.removeEventListener('resize', handleResize)
    }
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [handleResize])

  return height
}
